import axios from "axios";
import { requireResponse } from "../../core/errors/requireResponse";

// Collection / courier booking on a request (Dashboard v2).
//
// Its OWN endpoint, never the generic PUT /api/requests/{id}: that one treats a
// one-field payload as the whole request and wipes year / price (see the
// request-update partial-payload trap). Body: { collection_at: ISO | null,
// collection_note?: string ≤ 255 }. collection_at is always sent (null clears it).

export const COLLECTION_NOTE_MAX = 255;

export const saveRequestCollection = async (requestId, { collectionAt, note }) => {
  const body = { collection_at: collectionAt || null };
  // omitted = unchanged, "" = cleared (API contract)
  if (note !== undefined) body.collection_note = note ? String(note).slice(0, COLLECTION_NOTE_MAX) : "";
  const { data } = requireResponse(
    await axios.put(`/api/requests/${requestId}/collection`, body, { metadata: { silent: true } })
  );
  return data;
};

// <input type="datetime-local"> speaks the BROWSER's local wall clock
// ("2026-10-21T15:00"); the API speaks UTC ISO. These two convert between them.
const pad = (n) => String(n).padStart(2, "0");

export const isoToLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const localInputToIso = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};
